import { _get, _put, _post } from '@/common/request';
// 重置密码时的获取验证码
export function getResetSms(mobile) {
    return _put("/property/user/reset/sms", { mobile: mobile }, true);
}
// 获取七牛云token
export function getQiniuToken(params) {
    return _get("/v1/api/qiniu/token/" + params.bucket, params, { needPrefix: false });
}
// 获取Location七牛云token
export function getLocationQiniuToken(params) {
    return _get("/property/attract/upload", params, true);
}
// 获取行业列表
export function getIndustryList(params) {
    if (params === void 0) { params = null; }
    return _get("/property/industries", params, true);
}
// 获取推广形式
export function getSpreadWays() {
    return _get("/property/spread_ways", null, true);
}
// // 获取用户权限
// export function getUserPermission() {
//   return _get(`/property/user/permissions`, null, true);
// }
// 识别营业执照中的企业名称
// https://yapi.lanhanba.com/project/47/interface/api/24052
export function getBusinessLicenseName(params) {
    return _get("/property/orders/business_license/ocr", params, true);
}
// 获取钉钉鉴权信息
// https://yapi.lanhanba.com/project/140/interface/api/26421
export function getDingtalkConfig(params) {
    return _get("/external/dingtalk/jssdk_config", params, true);
}
// 获取省市区列
// https://yapi.lanhanba.com/project/319/interface/api/34167
export function getAreas() {
    return _get("/property/areas", null, true);
}
// 获取品牌列表
export function getBrandsList(params) {
    return _get("/property/brands", params, true);
}
// 获取全部部门列表
export function getAllDepartmentList() {
    return _get('/property/departments/all', null, true);
}
// 获取员工列表
export function getEmployees(params) {
    return _get('/property/staffs', params, true);
}
// 获取招商人员列表
export function getUserList(params) {
    if (params === void 0) { params = null; }
    return _get("/property/user/search", params, true);
}
// 获取招商人员
export function getUserSearch(params) {
    return _get('/property/user/searchAll', params, true);
}
// 获取邀请协作人链接
// https://yapi.lanhanba.com/project/319/interface/api/42685
export function getInviteLink(params) {
    return _get('/property/companies/invite', params, true);
}
// 获取公司下员工列表
// https://yapi.lanhanba.com/project/319/interface/api/42776
export function getCompanyMember(params) {
    return _get('/property/companies/member', params, true);
}
// 快速新建展位
// https://yapi.lanhanba.com/project/319/interface/api/42706
export function postBoothsBatch(params) {
    return _post('/property/booths/batch', params, true);
}
// 完善公司信息
// https://yapi.lanhanba.com/project/319/interface/api/42713
export function postCompleteCompany(params) {
    return _post('/property/complete/company', params, true);
}
// 获取公司下员工列表
// https://yapi.lanhanba.com/project/319/interface/api/42986
export function getCompanyInfo(params) {
    return _get('/property/company/info', params, true);
}
// 营业执照ORC识别
// https://yapi.lanhanba.com/project/319/interface/api/42972
export function postCompanyOrc(params) {
    return _post('/property/company/orc', params, true);
}
// 修改用户信息
// https://yapi.lanhanba.com/project/319/interface/api/42923
export function postUserUpdate(params) {
    return _post('/property/user/update', params, true);
}
/**
 * 获取当前用户配置
 * https://yapi.lanhanba.com/project/319/interface/api/64112
 * @param {*} params
 */
export function getUserConfig() {
    return _post('/property/user/config', {}, true);
}
// 查询自定义列表字段
// https://yapi.lanhanba.com/project/378/interface/api/46017
export function getCustomTableField(params) {
    return _get('/mirage/api/account/config/findCustomField', params, { needPrefix: false });
}
// 编辑自定义列表字段
// https://yapi.lanhanba.com/project/378/interface/api/45079
export function postCustomTableField(params) {
    return _post('/mirage/api/account/config/customField', params, { needPrefix: false });
}
